import { createSelector } from "@reduxjs/toolkit"
import { 
    CHANGE_REQUEST_STATUS_PENDING,
    CHANGE_REQUEST_TYPE_MAIN_AGENT 
} from "../../app/constants"

export const mainAgentChangeRequestSelector = createSelector(
    [(state) => state.primaryAgencyApplication?.application], 
    (agencyApplication) => {
        return {
            changeRequests : agencyApplication?.businessLicenceData?.changeRequests ?? []
        }
    }
)

export const currentPendingMainAgentChangeRequests = createSelector(
    [(state) => state.primaryAgencyApplication?.application], 
    (agencyApplication) => {
        const { changeRequests } = agencyApplication?.businessLicenceData
        const currentPendingRequest = changeRequests?.find(request => (request.changeRequestType === CHANGE_REQUEST_TYPE_MAIN_AGENT 
                                                        && request.changeRequestStatus === CHANGE_REQUEST_STATUS_PENDING))
        return { 
            mainAgentChangeRequest : currentPendingRequest ?? {}
        }
    }
)
